<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><path fill-rule="evenodd" d="M3.512 26.308a1 1 0 01-.679-.947V11.528a1 1 0 112 0v12.907h13a1 1 0 110 2H3.999a.996.996 0 01-.487-.127z" clip-rule="evenodd"/><path d="M6.493 6.535c0-.572.463-1.035 1.035-1.035h20.694c.572 0 1.035.463 1.035 1.035v2.587H6.493V6.535zm0 5.82h22.764v8.666c0 .571-.463 1.035-1.035 1.035H7.528a1.035 1.035 0 01-1.035-1.035v-8.666z"/></svg>
</template>

<script>
export default {
  name: 'financeCreditCardsFilled'
}
</script>
